import { GPTGameIcon } from 'src/EXPERIMENTAL_LIB/gpt/icons';

export const LuckyCardEventIcon: GPTGameIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}>
    <path
      d="M15.5 22.22C15.11 22.78 14.79 23.12 14.58 23.16H14.56C14.44 23.17 14.25 23.16 14.02 23.11H13.98C12.96 22.9 11.06 22.19 9.11 21.34C9.07 21.32 9.03 21.3 8.99 21.29C7.05 20.44 5.08 19.45 3.9 18.69C3.31 18.31 2.92 17.99 2.83 17.76C2.81 17.71 2.8 17.64 2.8 17.54C2.75 15.41 7.66 2.92 8.73 2.54C9.72 2.19 12.69 3.11 15.56 4.3L15.79 4.4C18.83 5.68 21.7 7.23 21.88 7.81C22.17 8.79 17.73 19.06 15.52 22.24L15.5 22.22Z"
      fill="#868686"
    />
    <path
      d="M14.39 22.15C14.1 22.52 13.86 22.75 13.7 22.78C13.56 22.8 13.35 22.78 13.07 22.72C12.2 22.54 10.72 22.01 9.12 21.33C9.08 21.31 9.04 21.29 9 21.28C6.33 20.16 3.35 18.66 2.31 17.79C2.12 17.63 2 17.49 1.95 17.38C1.59 16.51 4.1 9.52 6.01 5.32C6.81 3.55 7.51 2.28 7.84 2.16C8.93 1.77 12.44 2.94 15.56 4.3L15.79 4.4C18.48 5.59 20.83 6.9 20.99 7.43C21.29 8.45 16.52 19.42 14.41 22.17L14.39 22.15Z"
      fill="white"
    />
    <path
      d="M9.24002 2.15001C9.24002 2.15001 15.73 3.62001 20.98 7.41001L21.87 7.79001C21.87 7.79001 21.64 7.04001 18.66 5.50001C16.82 4.55001 13.39 2.98001 9.24002 2.15001Z"
      fill="white"
    />
    <path
      d="M14.59 23.16H14.57C14.51 23.16 14.34 23.16 14.03 23.11H13.99C13.18 22.98 11.44 22.53 8.19002 21.07C3.38002 18.91 2.36002 17.85 2.30002 17.79C2.30002 17.79 2.91002 18.15 3.90002 18.68C5.28002 19.43 7.39002 20.51 9.60002 21.41C9.78002 21.49 9.95002 21.55 10.12 21.62C10.99 21.97 11.71 22.24 12.29 22.45H12.3C12.59 22.56 12.84 22.65 13.07 22.72C14.17 23.09 14.59 23.16 14.59 23.16Z"
      fill="#898989"
    />
    <g opacity={0.9}>
      <mask
        id="mask0_3459_828"
        style={{
          maskType: 'luminance'
        }}
        maskUnits="userSpaceOnUse"
        x={1}
        y={2}
        width={21}
        height={21}>
        <path
          d="M14.43 22.15C14.14 22.52 13.91 22.75 13.74 22.77C13.6 22.79 13.39 22.77 13.11 22.71C12.24 22.53 10.76 22 9.16 21.33C9.12 21.31 9.08 21.29 9.04 21.28C6.36 20.16 3.38 18.68 2.34 17.8C2.15 17.64 2.03 17.5 1.98 17.39C1.62 16.52 4.12 9.52 6.01 5.32C6.81 3.55 7.5 2.28 7.83 2.16C8.92 1.76 12.43 2.92 15.56 4.28L15.79 4.38C18.49 5.57 20.84 6.87 20.99 7.4C21.29 8.42 16.55 19.4 14.44 22.16H14.43V22.15Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_3459_828)">
        <path
          d="M14.87 25.85L24.06 4.78L8.86001 -1.69L-0.329987 19.39L14.87 25.85Z"
          fill="#5AA91C"
        />
        <path
          d="M23.58 5.88L23.89 5.17L8.69003 -1.3L8.38004 -0.590003L23.58 5.88Z"
          fill="#389B00"
        />
        <path
          d="M22.97 7.26999L23.28 6.56999L8.08002 0.0999908L7.77002 0.809991L22.97 7.26999Z"
          fill="#389B00"
        />
        <path d="M22.36 8.67L22.67 7.97L7.47003 1.5L7.16003 2.21L22.36 8.67Z" fill="#389B00" />
        <path
          d="M21.75 10.07L22.06 9.36999L6.86002 2.89999L6.55002 3.60999L21.75 10.07Z"
          fill="#389B00"
        />
        <path d="M21.14 11.47L21.45 10.77L6.25003 4.3L5.94003 5.01L21.14 11.47Z" fill="#389B00" />
        <path d="M20.53 12.87L20.84 12.16L5.64002 5.7L5.33002 6.41L20.53 12.87Z" fill="#389B00" />
        <path
          d="M19.92 14.27L20.23 13.56L5.03003 7.09999L4.72003 7.80999L19.92 14.27Z"
          fill="#389B00"
        />
        <path d="M19.31 15.67L19.62 14.96L4.42002 8.5L4.11002 9.2L19.31 15.67Z" fill="#389B00" />
        <path d="M18.7 17.07L19.01 16.36L3.81003 9.89999L3.50003 10.6L18.7 17.07Z" fill="#389B00" />
        <path d="M18.09 18.47L18.4 17.76L3.20001 11.3L2.89001 12L18.09 18.47Z" fill="#389B00" />
        <path d="M17.48 19.87L17.79 19.16L2.59003 12.69L2.28003 13.4L17.48 19.87Z" fill="#389B00" />
        <path d="M16.87 21.27L17.18 20.56L1.98001 14.09L1.67001 14.8L16.87 21.27Z" fill="#389B00" />
        <path d="M16.26 22.67L16.57 21.96L1.37003 15.49L1.06003 16.2L16.26 22.67Z" fill="#389B00" />
        <path
          d="M15.65 24.06L15.96 23.36L0.760012 16.89L0.450012 17.6L15.65 24.06Z"
          fill="#389B00"
        />
        <path
          d="M15.04 25.46L15.35 24.76L0.150027 18.29L-0.159973 19L15.04 25.46Z"
          fill="#389B00"
        />
      </g>
    </g>
    <g
      style={{
        mixBlendMode: 'multiply'
      }}
      opacity={0.3}>
      <path
        d="M8.38001 2.85C7.26001 2.97 4.50001 11.15 5.07001 14.34C5.64001 17.53 15.95 15.65 18.01 13.65C20.07 11.64 20.02 7.86 19.01 6.56C18 5.26 9.60001 2.72 8.38001 2.85Z"
        fill="#F5F5F5"
      />
    </g>
    <g
      style={{
        mixBlendMode: 'overlay'
      }}
      opacity={0.3}>
      <path
        d="M6.51002 19.96C4.50002 18.31 15.38 17.17 16.26 17.21C17.14 17.25 14.59 22.25 13.75 22.68C12.91 23.11 6.51002 19.96 6.51002 19.96Z"
        fill="#F6F6F6"
      />
    </g>
    <g
      style={{
        mixBlendMode: 'multiply'
      }}
      opacity={0.8}>
      <path
        d="M21.4 7.59C21.18 7.49 19.85 11.58 17.73 16.16C15.61 20.74 15 21.57 15.15 21.85C15.31 22.12 18.2 17.68 19.68 14.05C21.16 10.42 21.89 8.06 21.8 7.94C21.71 7.83 21.4 7.58 21.4 7.58V7.59Z"
        fill="#DFDFDF"
      />
    </g>
    <g
      style={{
        mixBlendMode: 'multiply'
      }}
      opacity={0.8}>
      <path
        d="M15.5 22.22C15.11 22.78 14.79 23.12 14.58 23.16H14.56C14.44 23.17 14.25 23.16 14.02 23.11H13.98C13.17 22.98 11.43 22.53 8.18001 21.07C3.37001 18.91 2.35001 17.85 2.29001 17.79C2.10001 17.63 1.98001 17.49 1.93001 17.38C1.57001 16.51 4.08001 9.52001 5.99001 5.32001C5.25001 7.19001 2.31001 14.73 2.26001 16.44C2.26001 16.79 2.44001 17.16 2.78001 17.54C3.50001 18.35 4.89001 19.2 6.47001 19.95C7.19001 20.29 7.95001 20.62 8.70001 20.92C10.72 21.72 12.93 22.03 14.27 22.15H14.38C15.03 22.21 15.45 22.22 15.49 22.22H15.5Z"
        fill="#FCFCFC"
      />
    </g>
    <path
      opacity={0.27}
      d="M17.14 5.24001C15.81 4.78001 16.22 6.75001 17.07 7.80001C17.93 8.85001 19.77 7.29001 20.07 7.03001C20.37 6.77001 17.94 5.52001 17.13 5.25001H17.14V5.24001Z"
      fill="#F6F6F6"
    />
    <g
      style={{
        mixBlendMode: 'multiply'
      }}
      opacity={0.78}>
      <path
        d="M2.32 18.22C2.32 18.22 7.12 20.21 11.27 20.74C15.78 21.32 16.01 20.35 16.61 18.29C17 16.93 18.46 8.07001 18.55 6.75001C18.64 5.43001 18.2 5.24001 18.2 5.24001L2.31 17.68V18.21L2.32 18.22Z"
        fill="#555555"
      />
    </g>
    <path
      d="M15.71 18.85C15.48 19.49 15.25 19.9 15.05 19.99H15.03C14.91 20.04 14.73 20.07 14.49 20.08H14.45C13.41 20.14 11.39 19.92 9.29 19.58C9.25 19.58 9.2 19.57 9.16 19.56C7.07 19.22 4.91 18.75 3.58 18.32C2.91 18.1 2.45 17.88 2.31 17.69C2.28 17.65 2.25 17.58 2.22 17.49C1.64 15.44 3.26 2.12 4.2 1.48C5.07 0.889997 8.18001 1.04 11.26 1.48L11.5 1.52C14.77 2 17.93 2.77 18.25 3.3C18.78 4.18 17.05 15.23 15.71 18.86V18.85Z"
      fill="#BBBBBB"
    />
    <path
      d="M14.62 19.06C14.44 19.49 14.26 19.77 14.1 19.84C13.97 19.89 13.76 19.93 13.47 19.94C12.58 19.98 11.02 19.84 9.30002 19.59C9.26002 19.59 9.21002 19.58 9.17002 19.57C6.30002 19.15 3.04002 18.45 1.82002 17.86C1.60002 17.75 1.44002 17.65 1.37002 17.55C0.800019 16.8 1.49002 9.40001 2.28002 4.85001C2.62002 2.94001 2.97002 1.53001 3.26002 1.33001C4.22002 0.68001 7.91002 0.93001 11.27 1.47001L11.51 1.51001C14.42 1.99001 17.02 2.67001 17.3 3.14001C17.85 4.05001 15.98 15.86 14.62 19.06Z"
      fill="url(#paint0_linear_3459_828)"
    />
    <path
      d="M4.61001 0.980003C4.61001 0.980003 11.26 0.780003 17.29 3.13L18.24 3.28C18.24 3.28 17.83 2.61 14.56 1.87C12.54 1.41 8.83001 0.750003 4.60001 0.980003H4.61001Z"
      fill="#A8A8A8"
    />
    <path
      d="M15.05 19.98H15.03C14.97 20 14.81 20.04 14.49 20.07H14.45C13.63 20.14 11.84 20.15 8.33 19.55C3.13 18.66 1.88 17.9 1.81 17.85C1.81 17.85 2.49 18.05 3.58 18.31C5.1 18.69 7.42 19.21 9.78 19.53C9.97 19.56 10.16 19.58 10.33 19.6C11.26 19.72 12.02 19.8 12.64 19.86H12.65C12.95 19.89 13.22 19.91 13.46 19.93C14.62 20.01 15.04 19.98 15.04 19.98H15.05Z"
      fill="#9B9B9B"
    />
    <g
      style={{
        mixBlendMode: 'multiply'
      }}
      opacity={0.3}>
      <path
        d="M3.96002 1.88001C2.91002 2.28001 2.28002 10.89 3.63002 13.83C4.98002 16.78 14.49 12.38 15.99 9.92001C17.49 7.46001 16.49 3.81001 15.18 2.81001C13.88 1.81001 5.11002 1.45001 3.96002 1.88001Z"
        fill="#EFEFEF"
      />
    </g>
    <g
      style={{
        mixBlendMode: 'overlay'
      }}
      opacity={0.3}>
      <path
        d="M6.44002 18.91C4.08002 17.82 14.33 13.99 15.19 13.81C16.05 13.62 14.83 19.11 14.13 19.73C13.43 20.35 6.44002 18.91 6.44002 18.91Z"
        fill="white"
      />
    </g>
    <g
      style={{
        mixBlendMode: 'multiply'
      }}
      opacity={0.5}>
      <path
        d="M17.75 3.2C17.51 3.16 17.25 7.45 16.34 12.41C15.43 17.38 15.05 18.33 15.27 18.56C15.49 18.79 17.18 13.76 17.7 9.88C18.22 6 18.34 3.53 18.22 3.44C18.11 3.35 17.74 3.2 17.74 3.2H17.75Z"
        fill="#90847F"
      />
    </g>
    <g
      style={{
        mixBlendMode: 'multiply'
      }}
      opacity={0.8}>
      <path
        d="M15.71 18.85C15.48 19.49 15.25 19.9 15.05 19.99H15.03C14.91 20.04 14.73 20.07 14.49 20.08H14.45C13.63 20.15 11.84 20.16 8.33001 19.56C3.13001 18.67 1.88001 17.91 1.81001 17.86C1.59001 17.75 1.43001 17.65 1.36001 17.55C0.790009 16.8 1.48001 9.40001 2.27001 4.85001C2.02001 6.84001 1.06001 14.88 1.45001 16.55C1.53001 16.89 1.81001 17.21 2.23001 17.49C3.13001 18.09 4.69001 18.56 6.40001 18.9C7.18001 19.05 8.00001 19.18 8.80001 19.28C10.96 19.55 13.18 19.3 14.5 19.08C14.54 19.08 14.57 19.07 14.61 19.06C15.26 18.95 15.66 18.86 15.7 18.85H15.71Z"
        fill="#464646"
      />
    </g>
    <path
      d="M13.04 1.99C11.64 1.88 12.52 3.69 13.62 4.48C14.71 5.28 16.11 3.31 16.33 2.98C16.56 2.65 13.89 2.06 13.04 1.99Z"
      fill="white"
    />
    <g opacity={0.7}>
      <mask
        id="mask1_3459_828"
        style={{
          maskType: 'luminance'
        }}
        maskUnits="userSpaceOnUse"
        x={1}
        y={0}
        width={17}
        height={20}>
        <path
          d="M14.62 19.06C14.44 19.49 14.26 19.77 14.1 19.84C13.97 19.89 13.76 19.93 13.47 19.94C12.58 19.98 11.02 19.84 9.30002 19.59C9.26002 19.59 9.21002 19.58 9.17002 19.57C6.30002 19.15 3.04002 18.45 1.82002 17.86C1.60002 17.75 1.44002 17.65 1.37002 17.55C0.800019 16.8 1.49002 9.40001 2.28002 4.85001C2.62002 2.94001 2.97002 1.53001 3.26002 1.33001C4.22002 0.68001 7.91002 0.93001 11.27 1.47001L11.51 1.51001C14.42 1.99001 17.02 2.67001 17.3 3.14001C17.85 4.05001 15.98 15.86 14.62 19.06Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask1_3459_828)">
        <path
          d="M15.96 22.53L19.64 -0.169988L3.31 -2.65999L-0.369995 20.04L15.96 22.53Z"
          fill="#5AA91C"
        />
        <path
          d="M19.45 1.01001L19.57 0.25001L3.24003 -2.23999L3.12003 -1.47999L19.45 1.01001Z"
          fill="#389B00"
        />
        <path
          d="M19.2 2.52L19.33 1.76L3.00003 -0.729996L2.87003 0.0300043L19.2 2.52Z"
          fill="#389B00"
        />
        <path
          d="M18.96 4.03001L19.08 3.27001L2.75 0.780014L2.63 1.54001L18.96 4.03001Z"
          fill="#389B00"
        />
        <path
          d="M18.71 5.54001L18.84 4.77001L2.51001 2.28001L2.39001 3.04001L18.71 5.54001Z"
          fill="#389B00"
        />
        <path
          d="M18.47 7.04001L18.59 6.28001L2.26001 3.79001L2.14001 4.55001L18.47 7.04001Z"
          fill="#389B00"
        />
        <path d="M18.23 8.55L18.35 7.79L2.02002 5.3L1.90002 6.06L18.23 8.55Z" fill="#389B00" />
        <path d="M17.98 10.06L18.11 9.29L1.78002 6.8L1.65002 7.56L17.98 10.06Z" fill="#389B00" />
        <path d="M17.74 11.56L17.86 10.8L1.53 8.31001L1.41 9.07001L17.74 11.56Z" fill="#389B00" />
        <path d="M17.49 13.07L17.62 12.31L1.29 9.82001L1.16 10.58L17.49 13.07Z" fill="#389B00" />
        <path
          d="M17.25 14.58L17.37 13.81L1.04001 11.32L0.920013 12.09L17.25 14.58Z"
          fill="#389B00"
        />
        <path
          d="M17.01 16.08L17.13 15.32L0.800023 12.83L0.680023 13.59L17.01 16.08Z"
          fill="#389B00"
        />
        <path
          d="M16.76 17.59L16.88 16.83L0.560023 14.34L0.430023 15.1L16.76 17.59Z"
          fill="#389B00"
        />
        <path
          d="M16.52 19.1L16.64 18.34L0.310002 15.84L0.190002 16.61L16.52 19.1Z"
          fill="#389B00"
        />
        <path
          d="M16.27 20.6L16.4 19.84L0.0700024 17.35L-0.0599976 18.11L16.27 20.6Z"
          fill="#389B00"
        />
        <path
          d="M16.03 22.11L16.15 21.35L-0.179988 18.86L-0.299988 19.62L16.03 22.11Z"
          fill="#389B00"
        />
      </g>
    </g>
    <path
      d="M2.11002 17.4L4.08002 1.22L16.74 3.08L13.73 19.1L2.11002 17.39V17.4ZM4.20002 1.35L2.26002 17.31L13.59 18.98L16.57 3.17L4.20002 1.35Z"
      fill="#BBEA78"
    />
    <path
      d="M8.62001 12.5C7.26001 12.17 6.37001 10.84 6.65001 9.53C6.93001 8.22 8.26001 7.41 9.62001 7.74C10.98 8.07 11.87 9.4 11.59 10.71C11.31 12.02 9.98001 12.83 8.62001 12.5ZM8.64001 12.39C9.94001 12.7 11.21 11.93 11.48 10.68C11.74 9.43001 10.9 8.15 9.60001 7.84C8.30001 7.53 7.03001 8.3 6.76001 9.55C6.50001 10.8 7.34001 12.08 8.64001 12.39Z"
      fill="#BBEA78"
    />
    <path
      d="M15.36 11.11C15.36 11.11 13.94 10.9 12.05 10.62L6.15003 9.74999C4.27003 9.46999 2.84003 9.25999 2.84003 9.25999"
      fill="#5AA91C"
    />
    <path
      d="M15.21 11.14L15.23 11.03L3.11003 9.25999L3.09003 9.35999L15.21 11.14Z"
      fill="#BBEA78"
    />
    <path
      d="M6.46002 4.27L6.89002 1.63L13.92 2.66L13.49 5.3L6.46002 4.27ZM7.01002 1.76L6.62002 4.19L13.37 5.18L13.76 2.75L7.01002 1.76Z"
      fill="#BBEA78"
    />
    <path
      d="M9.76001 6.18001C8.68001 6.02001 7.91001 5.25001 8.04001 4.45001V4.40001L11.95 4.97001V5.02001C11.81 5.81001 10.83 6.33001 9.76001 6.17001V6.18001ZM9.77001 6.08001C10.75 6.22001 11.64 5.77001 11.79 5.06001L8.17001 4.53001C8.09001 5.25001 8.80001 5.94001 9.77001 6.08001Z"
      fill="#BBEA78"
    />
    <path
      d="M4.29001 17.71L4.72001 15.07L11.75 16.1L11.32 18.74L4.29001 17.71ZM4.84001 15.2L4.45001 17.63L11.2 18.62L11.59 16.19L4.84001 15.2Z"
      fill="#BBEA78"
    />
    <path
      d="M6.26001 15.41V15.36C6.40001 14.57 7.38001 14.05 8.45001 14.21C9.53001 14.37 10.3 15.14 10.17 15.94V15.99L6.26001 15.42V15.41ZM10.04 15.86C10.12 15.14 9.41001 14.45 8.44001 14.31C7.46001 14.17 6.57001 14.62 6.42001 15.33L10.04 15.86Z"
      fill="#BBEA78"
    />
    <g opacity={0.3}>
      <path
        d="M5.12003 16.96L5.42003 17.77L11.43 18.58L11.61 17.14L11.24 16.58L10.77 16.52C10.77 16.52 10.81 15.41 9.90003 15.16C9.65003 15.1 9.69003 11.76 9.90003 11.43C10.52 10.39 11 10.69 12.28 8.99001C12.55 8.65001 13.4 7.41001 13.63 5.97001C13.81 4.82001 13.87 4.49001 13.87 4.49001C13.87 4.49001 13.8 3.47001 11.61 4.19001C10.5 4.55001 9.23003 9.87001 9.08003 10.82C8.93003 11.77 9.33003 14.58 8.80003 15.47C8.27003 16.36 5.16003 16.94 5.16003 16.94H5.15003L5.12003 16.96Z"
        fill="black"
      />
      <path
        d="M7.11001 4.53001C7.11001 4.53001 6.13001 4.03001 5.62001 4.03001C5.00001 4.03001 4.47001 4.86001 5.12001 5.89001C5.52001 6.51001 6.64001 6.70001 7.34001 9.13001C7.22001 6.08001 4.75001 5.96001 5.24001 4.69001C5.62001 3.71001 6.87001 4.90001 7.12001 4.85001C7.37001 4.81001 7.12001 4.52001 7.12001 4.52001L7.11001 4.53001Z"
        fill="black"
      />
      <path
        d="M13.6 5C13.6 5 15.24 4.7 15.75 5.49C16.03 5.93 16.25 6.97001 15.29 7.78C14.73 8.25001 13.06 8.55 12.09 9.01C11.32 9.38 12.05 8.15 12.53 8.21C13.01 8.27 15.51 7.94 15.58 6.39C15.65 4.94 14.07 5.46001 13.69 5.34001C13.31 5.22001 13.6 5 13.6 5Z"
        fill="black"
      />
    </g>
    <path
      d="M9.97003 10L9.10003 9.88L8.51003 9.79L7.64003 9.67L7.98003 10.17C8.16003 10.44 8.22003 10.78 8.11003 11.07L6.94003 14.87L9.09003 15.17V11.2C9.09003 10.87 9.24003 10.58 9.49003 10.37L9.96003 9.99H9.97003V10Z"
      fill="#FFDD6A"
    />
    <g
      opacity={0.3}
      style={{
        mixBlendMode: 'multiply'
      }}>
      <path
        d="M8.52002 9.81L7.65002 9.69L7.99002 10.19C8.06002 10.29 8.11002 10.41 8.14002 10.55C8.14002 10.55 8.30002 10.28 8.75002 10.34C9.20002 10.4 9.27002 10.71 9.27002 10.71C9.33002 10.61 9.42002 10.5 9.52002 10.41L9.99002 10.03L9.12002 9.91L8.53002 9.82L8.52002 9.81Z"
        fill="#FF9D35"
      />
    </g>
    <path
      opacity={0.3}
      d="M8.73003 9.83999L7.80003 9.70999L7.95003 9.85999C8.26003 10.19 8.36003 10.64 8.23003 11.07L7.06003 14.9L7.50003 14.96L8.71003 9.81999H8.72003L8.73003 9.83999Z"
      fill="white"
    />
    <path
      d="M9.10003 14.53L7.16003 14.26C7.16003 14.26 7.07003 14.2 7.09003 14.16C7.11003 14.12 7.15003 14.07 7.19003 14.09L9.13003 14.36C9.13003 14.36 9.22003 14.42 9.20003 14.46C9.18003 14.5 9.14003 14.55 9.10003 14.53Z"
      fill="#FFB248"
    />
    <path
      d="M9.10003 13.87L7.35003 13.63C7.35003 13.63 7.26003 13.57 7.28003 13.53C7.30003 13.49 7.34003 13.44 7.38003 13.46L9.13003 13.7C9.13003 13.7 9.22003 13.76 9.20003 13.8C9.18003 13.84 9.14003 13.89 9.10003 13.87Z"
      fill="#FFB248"
    />
    <path
      d="M6.67002 8.06999C6.40002 7.36999 5.90002 6.94999 5.22002 6.62999C4.36002 6.22999 3.47002 5.35999 3.52002 4.28999C3.55002 3.14999 4.69002 2.33999 5.75002 2.76999C6.13002 2.91999 6.43002 3.20999 6.65002 3.54999L6.41002 3.72999C6.01002 3.13999 5.33002 2.79999 4.63002 3.10999C3.99002 3.38999 3.71002 4.17999 3.95002 4.80999C4.17002 5.47999 4.78002 5.94999 5.40002 6.24999C5.73002 6.40999 6.10002 6.58999 6.41002 6.88999C6.71002 7.18999 6.93002 7.52999 7.09002 7.89999L6.63002 8.08999H6.66002L6.67002 8.06999Z"
      fill="#FFDD6A"
    />
    <g opacity={0.5}>
      <path
        d="M4.89001 2.72C4.89001 2.72 4.85001 2.72 4.82001 2.73C4.58001 2.79 4.35001 2.91 4.15001 3.07C3.79001 3.37 3.59001 3.81 3.57001 4.28C3.57001 4.29 3.57001 4.31 3.60001 4.31C3.60001 4.31 3.63001 4.3 3.64001 4.28C3.64001 3.84 3.85001 3.41 4.19001 3.13C4.38001 2.97 4.59001 2.86 4.83001 2.8H4.90001C4.90001 2.8 4.93001 2.77 4.93001 2.76C4.93001 2.75 4.90001 2.73 4.89001 2.73V2.72Z"
        fill="white"
      />
      <path
        d="M5.75001 2.81C5.54001 2.74 5.34001 2.69 5.13001 2.69C5.12001 2.69 5.10001 2.7 5.10001 2.73C5.10001 2.74 5.11001 2.76 5.13001 2.76C5.34001 2.76 5.53001 2.79 5.72001 2.86C5.72001 2.86 5.75001 2.86 5.76001 2.83C5.76001 2.82 5.76001 2.79 5.75001 2.79V2.81Z"
        fill="white"
      />
    </g>
    <g
      opacity={0.4}
      style={{
        mixBlendMode: 'multiply'
      }}>
      <path
        d="M6.67003 8.07L7.13003 7.88C6.97003 7.51 6.75003 7.15 6.45003 6.87C6.20003 6.65 5.92003 6.49 5.65003 6.35C5.37003 6.39 4.94003 6.39 4.50003 6.17C4.74003 6.36 4.99003 6.53 5.24003 6.64C5.92003 6.97 6.42003 7.38 6.69003 8.08H6.68003L6.67003 8.07Z"
        fill="#FF9D35"
      />
    </g>
    <path
      d="M11.41 8.72C11.87 8.11 12.48 7.85 13.22 7.73C14.17 7.57 15.26 6.99 15.54 5.95C15.85 4.84 14.99 3.76 13.84 3.88C13.43 3.91 13.06 4.13 12.74 4.38L12.92 4.6C13.47 4.14 14.24 4.01 14.8 4.48C15.32 4.92 15.36 5.75 14.95 6.3C14.54 6.89 13.83 7.17 13.13 7.29C12.76 7.36 12.36 7.42 11.98 7.62C11.61 7.81 11.28 8.09 11.02 8.4L11.4 8.71H11.41V8.72Z"
      fill="#FFDD6A"
    />
    <g opacity={0.5}>
      <path
        d="M14.68 4.07001C14.68 4.07001 14.72 4.10001 14.74 4.10001C14.96 4.22001 15.14 4.40001 15.29 4.60001C15.54 4.98001 15.62 5.47001 15.48 5.92001C15.48 5.93001 15.45 5.95001 15.44 5.95001C15.44 5.95001 15.41 5.92001 15.41 5.91001C15.53 5.48001 15.45 5.02001 15.22 4.65001C15.09 4.44001 14.91 4.28001 14.7 4.16001C14.69 4.16001 14.66 4.13001 14.64 4.13001C14.62 4.13001 14.61 4.10001 14.63 4.09001C14.63 4.08001 14.66 4.06001 14.67 4.08001H14.68V4.07001Z"
        fill="white"
      />
      <path
        d="M13.83 3.92C14.05 3.89 14.26 3.92 14.47 3.98C14.48 3.98 14.5 4.01 14.5 4.02C14.5 4.03 14.47 4.05 14.46 4.05C14.27 3.99 14.06 3.98 13.85 3.99C13.85 3.99 13.82 3.98 13.82 3.96C13.82 3.94 13.82 3.92 13.85 3.92H13.84H13.83Z"
        fill="white"
      />
    </g>
    <g
      opacity={0.4}
      style={{
        mixBlendMode: 'multiply'
      }}>
      <path
        d="M11.41 8.71999L11.03 8.40999C11.3 8.09999 11.61 7.81999 11.99 7.62999C12.3 7.47999 12.61 7.40999 12.91 7.34999C13.16 7.44999 13.58 7.56999 14.06 7.47999C13.78 7.59999 13.5 7.68999 13.22 7.72999C12.48 7.84999 11.86 8.10999 11.41 8.71999Z"
        fill="#FF9D35"
      />
    </g>
    <path
      d="M13.3 3.68L6.31003 2.72C5.72003 6.61 6.81003 10 8.74003 10.25C10.66 10.5 12.71 7.57 13.3 3.68Z"
      fill="#FFC051"
    />
    <path
      d="M13.3 3.68L6.31003 2.72C5.72003 6.61 6.81003 10 8.74003 10.25C10.66 10.5 12.71 7.57 13.3 3.68Z"
      fill="#FFB248"
    />
    <path
      d="M13.3 3.68L6.31003 2.72C6.24003 2.72 6.18003 2.63 6.19003 2.56C6.20003 2.49 6.28003 2.43 6.35003 2.44L13.34 3.4C13.41 3.4 13.47 3.49 13.46 3.56C13.45 3.63 13.37 3.69 13.3 3.68Z"
      fill="#FFDD6A"
    />
    <path
      d="M10.61 9.49999L10.39 8.71999L9.93003 9.41999L9.71003 8.63999L9.25003 9.33999L9.03003 8.55999L8.57003 9.25999L8.35003 8.47999L7.89003 9.17999L7.67003 8.39999L7.21003 9.09999L6.99003 8.31999L6.84003 8.53999C7.30003 9.55999 7.95003 10.23 8.76003 10.35C9.57003 10.47 10.4 9.98999 11.14 9.13999L11.07 8.88999L10.61 9.58999V9.55999V9.49999Z"
      fill="#FF9D35"
    />
    <path
      d="M6.21002 3.64L6.37002 3.39L6.70002 4.5L7.34002 3.52L7.67002 4.63L8.31002 3.65L8.64002 4.76L9.28002 3.78L9.61002 4.89L10.25 3.91L10.58 5.02L11.22 4.04L11.55 5.15L12.19 4.17L12.52 5.28L13.16 4.3L13.25 4.6C13.31 4.3 13.37 3.99 13.41 3.68L6.42002 2.72C6.38002 3.03 6.33002 3.34 6.32002 3.64H6.26002H6.21002Z"
      fill="#FF9D35"
    />
    <g
      opacity={0.3}
      style={{
        mixBlendMode: 'multiply'
      }}>
      <path
        d="M8.64003 10.24H8.65003C10.47 10.49 12.57 7.50001 13.15 3.65001L11.95 3.49001C11.37 7.31001 9.89003 10.28 8.62003 10.24H8.63003H8.64003Z"
        fill="#FF9D35"
      />
    </g>
    <path
      opacity={0.4}
      d="M8.80002 10.27C7.10002 9.97001 6.02002 6.33001 6.64002 2.77001L6.45002 2.74001C5.87002 6.60001 6.92002 9.95001 8.80002 10.27Z"
      fill="white"
    />
    <path
      opacity={0.2}
      d="M8.82 10.27C8.02 10.08 7.16 6.48 7.77 2.93L6.79 2.8C6.21 6.66 7.44 10.02 8.8 10.27H8.81H8.82Z"
      fill="white"
    />
    <g opacity={0.5}>
      <path
        d="M11.08 3.14L8.10003 2.73C8.10003 2.73 8.06003 2.73 8.06003 2.76C8.06003 2.79 8.06003 2.8 8.09003 2.8L11.07 3.21C11.07 3.21 11.11 3.21 11.11 3.18C11.11 3.15 11.11 3.14 11.08 3.14Z"
        fill="white"
      />
      <path
        d="M7.68002 2.68L6.44002 2.5C6.44002 2.5 6.40002 2.5 6.40002 2.53C6.40002 2.56 6.40002 2.57 6.43002 2.57L7.67002 2.75C7.67002 2.75 7.71002 2.75 7.71002 2.72C7.71002 2.69 7.71002 2.68 7.68002 2.68Z"
        fill="white"
      />
    </g>
    <path d="M11.08 16.03L4.81001 15.17L4.57001 16.72L10.86 17.6L11.08 16.03Z" fill="#5E0A29" />
    <path
      d="M9.99001 16.27L5.82001 15.69C5.82001 15.69 5.78001 15.7 5.76001 15.73L5.67001 16.35C5.67001 16.35 5.67001 16.39 5.71001 16.41L9.88001 16.99C9.88001 16.99 9.92001 16.98 9.94001 16.95L10.03 16.33C10.03 16.33 10.03 16.29 9.99001 16.27Z"
      fill="#FFDD6A"
    />
    <path
      d="M9.91002 16.34C9.91002 16.34 9.92002 16.34 9.92002 16.37L9.85002 16.89C9.85002 16.89 9.85002 16.9 9.82002 16.9L5.75002 16.34C5.75002 16.34 5.74002 16.34 5.74002 16.31L5.81002 15.79C5.81002 15.79 5.81002 15.78 5.84002 15.78L9.91002 16.34ZM9.93002 16.32L5.86002 15.76C5.86002 15.76 5.82002 15.76 5.82002 15.79L5.75002 16.31V16.34H5.78002L9.85002 16.9C9.85002 16.9 9.89002 16.9 9.89002 16.87L9.96002 16.35V16.32H9.93002Z"
      fill="#FFB248"
    />
    <path
      d="M10.1 15.9L5.79001 15.31C5.85001 14.87 6.16001 14.54 6.46001 14.58L9.67001 15.02C9.98001 15.06 10.16 15.45 10.1 15.89V15.9Z"
      fill="#FFB248"
    />
    <g
      opacity={0.3}
      style={{
        mixBlendMode: 'multiply'
      }}>
      <path
        d="M7.96002 15.53C7.21002 15.43 6.52002 15.2 5.93002 14.91C5.87002 15.03 5.81002 15.16 5.80002 15.31L10.11 15.9C10.14 15.75 10.12 15.6 10.1 15.49C9.45002 15.62 8.72002 15.65 7.97002 15.55L7.96002 15.53Z"
        fill="#FF9D35"
      />
    </g>
    <g opacity={0.3}>
      <path
        d="M8.85001 15.01L7.33001 14.8C7.33001 14.8 7.29001 14.81 7.29001 14.84C7.29001 14.87 7.29001 14.9 7.32001 14.9L8.84001 15.11C8.84001 15.11 8.88001 15.1 8.88001 15.07C8.88001 15.04 8.88001 15.01 8.85001 15.01Z"
        fill="white"
      />
      <path
        d="M7.01001 14.76L6.39001 14.67C6.39001 14.67 6.35001 14.68 6.35001 14.71C6.35001 14.74 6.35001 14.77 6.38001 14.77L7.00001 14.86C7.00001 14.86 7.04001 14.85 7.04001 14.82C7.04001 14.79 7.04001 14.76 7.01001 14.76Z"
        fill="white"
      />
    </g>
    <g opacity={0.1}>
      <path
        d="M10.95 16.09L6.08001 15.42C6.08001 15.42 6.04001 15.42 6.04001 15.46C6.04001 15.5 6.04001 15.5 6.07001 15.5L10.94 16.17C10.94 16.17 10.98 16.17 10.98 16.13C10.98 16.09 10.98 16.09 10.95 16.09Z"
        fill="white"
      />
      <path
        d="M5.69 15.36L4.92 15.26C4.92 15.26 4.88 15.26 4.88 15.3C4.88 15.34 4.88 15.34 4.91 15.34L5.68 15.44C5.68 15.44 5.72 15.44 5.72 15.4C5.72 15.36 5.72 15.36 5.69 15.36Z"
        fill="white"
      />
    </g>
    <g
      opacity={0.3}
      style={{
        mixBlendMode: 'multiply'
      }}>
      <path d="M10.9 17.3L4.61001 16.43L4.57001 16.72L10.86 17.6L10.9 17.3Z" fill="#999999" />
    </g>
    <g
      opacity={0.2}
      style={{
        mixBlendMode: 'multiply'
      }}>
      <path d="M9.11 14.53L7.14 14.27L7.13 14.36L9.11 14.62V14.53Z" fill="#FF9D35" />
    </g>
    <g
      opacity={0.2}
      style={{
        mixBlendMode: 'multiply'
      }}>
      <path d="M9.11001 13.88L7.35001 13.63L7.32001 13.72L9.11001 13.97V13.88Z" fill="#FF9D35" />
    </g>
    <path
      d="M5.92002 15.84C5.92002 15.84 5.92002 15.81 5.89002 15.81C5.86002 15.81 5.86002 15.81 5.86002 15.84C5.86002 15.87 5.86002 15.87 5.89002 15.87C5.92002 15.87 5.92002 15.87 5.92002 15.84Z"
      fill="#FFB248"
    />
    <path
      d="M5.90003 15.84H5.89003V15.82L5.87003 15.84V15.82V15.84V15.85H5.89003V15.84H5.90003Z"
      fill="#FFDD6A"
    />
    <path
      d="M5.84003 16.28C5.84003 16.28 5.84003 16.25 5.81003 16.25C5.78003 16.25 5.78003 16.25 5.78003 16.28C5.78003 16.31 5.78003 16.31 5.81003 16.31C5.84003 16.31 5.84003 16.31 5.84003 16.28Z"
      fill="#FFB248"
    />
    <path
      d="M5.83002 16.28V16.27H5.81002H5.80002V16.28H5.81002V16.3L5.83002 16.28Z"
      fill="#FFDD6A"
    />
    <path
      d="M9.87003 16.38C9.87003 16.38 9.87003 16.35 9.84003 16.35C9.81003 16.35 9.81003 16.35 9.81003 16.38C9.81003 16.41 9.81003 16.41 9.84003 16.41C9.87003 16.41 9.87003 16.41 9.87003 16.38Z"
      fill="#FFB248"
    />
    <path
      d="M9.87001 16.38L9.85001 16.37H9.84001H9.82001V16.38H9.84001V16.4L9.85001 16.38H9.87001Z"
      fill="#FFDD6A"
    />
    <path
      d="M9.81003 16.83C9.81003 16.83 9.81003 16.8 9.78003 16.8C9.75003 16.8 9.75003 16.8 9.75003 16.83C9.75003 16.86 9.75003 16.86 9.78003 16.86C9.81003 16.86 9.81003 16.86 9.81003 16.83Z"
      fill="#FFB248"
    />
    <path
      d="M9.79001 16.83L9.78001 16.81V16.8L9.76001 16.81V16.83V16.84H9.78001V16.83H9.79001Z"
      fill="#FFDD6A"
    />
    <path
      opacity={0.2}
      d="M7.56002 15.93L6.18002 15.74L5.69002 16.07L5.65002 16.32C5.65002 16.32 5.68002 16.41 5.72002 16.41L6.65002 16.54L7.55002 15.93H7.56002Z"
      fill="white"
    />
    <path
      opacity={0.2}
      d="M7.14001 16.61L8.03001 16L7.81001 15.97L6.92001 16.58L7.14001 16.61Z"
      fill="white"
    />
    <path
      opacity={0.2}
      d="M9.44003 16.92L9.99003 16.55L10.02 16.35L9.22003 16.89L9.44003 16.92Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_3459_828"
        x1={7.67002}
        y1={19.35}
        x2={10.42}
        y2={1.34001}
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#DFDFDF" />
        <stop offset={1} stopColor="white" />
      </linearGradient>
    </defs>
  </svg>
);
